var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCrown = function SvgIconCrown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.081,
    height: 13.665,
    viewBox: "0 0 17.081 13.665",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.092,11.957H2.989a.428.428,0,0,0-.427.427v.854a.428.428,0,0,0,.427.427h11.1a.428.428,0,0,0,.427-.427v-.854A.428.428,0,0,0,14.092,11.957ZM15.8,3.416A1.281,1.281,0,0,0,14.519,4.7a1.255,1.255,0,0,0,.117.528L12.7,6.384a.853.853,0,0,1-1.18-.31L9.349,2.269a1.281,1.281,0,1,0-1.617,0L5.557,6.074a.853.853,0,0,1-1.18.31L2.447,5.226a1.281,1.281,0,1,0-1.166.753,1.308,1.308,0,0,0,.206-.021L3.416,11.1H13.665l1.93-5.146a1.308,1.308,0,0,0,.206.021,1.281,1.281,0,1,0,0-2.562Z",
    fill: "#f6c866"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCrown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-crown.8ad527a0.svg";
export { ForwardRef as ReactComponent };